import React, { useContext, useEffect, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import Footer from '../../components/footer/Footer'
import Navigation from '../../components/navigation/Navigation'
import './verifyProductsPurchase.css'

import queryString from 'query-string'
import { toast, ToastContainer } from 'react-toastify'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { ENDPOINT, getJWT } from '../../helpers/Helper'
import { CartContext } from '../../contexts/CartContext'

const renderLoading = () => (
    <div style={{ display: "flex", justifyContent: "center", padding: "1rem" }}>
        <Spinner animation="border" variant="darke" /> 
        <h3 style={{marginLeft: "1rem"}}>Verifying your Purchase</h3>
    </div>
)

function VerifyProductsPurchase() {
  const navigate = useNavigate();

  const { triggerReload } = useContext(CartContext);

    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);

        const { tx_ref, transaction_id } = queryString.parse(window.location.search); 

        axios.post(`${ENDPOINT}/cart/verify-payment`, { "tx_ref": tx_ref, "transaction_id": transaction_id }, { headers: { Authorization: `Bearer ${getJWT()}`}})
            .then(res => {
                toast("Purchase Successfully Verified.", {
                    type: "success",
                    position: "top-right",
                    autoClose: "5000",
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                });
                triggerReload();
                setLoading(false);
            })
            .catch(err => {
                toast(`Ooops! ${err.response.data.error}`, {
                    type: "error",
                    position: "top-right",
                    autoClose: "5000",
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: false,
                    draggable: false,
                    progress: undefined,
                })
                // navigate(`/error`)
            })

    }, [])

  return (
    <div className='verifyProductPurchase'>
      <Navigation background="theme-color" logo='https://res.cloudinary.com/emacon-production/image/upload/v1638427484/the-outlet/Artboard_7_copy_7png_j6chrh.png' />

      <div className='main-section'>
          <div className='section-1'>
              <img src="https://res.cloudinary.com/emacon-production/image/upload/v1648793433/the-outlet/THE_OUTLET_PNG_t6abcu.png" />
          </div>
          <h3 style={{ textAlign: "center", fontWeight: "bold"}}>
              {
                  loading ? renderLoading() : "THANK YOU FOR SHOPPING WITH US"
              }
          </h3>
          {
              loading ? null : <p style={{ textAlign: "center" }}>Your purchase has been successfully verified</p>
          }
          
      </div>

      <ToastContainer />

      <Footer/>
    </div>
  )
}

export default VerifyProductsPurchase